import { HiOutlinePencilSquare, HiArrowLeft, HiCamera } from "react-icons/hi2";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import useGetVariantList from "../../../../hooks/variants/useGetVariantList";

const ProductsVariants = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Parse product_name from query string
  const searchParams = new URLSearchParams(location.search);
  const productName = searchParams.get("product_name") || "";

  const { configData } = useGetVariantList({ productId: id });

  // console.log("Variant list data:", configData);

  return (
    <div className="bg-white border border-neutral-200 shadow-sm p-4">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center">
          <button
            className="flex items-center gap-2 text-gray-600 hover:text-gray-800 text-sm px-3 py-2 rounded-md"
            onClick={() => navigate(-1)}
          >
            <HiArrowLeft className="text-gray-600 w-6 h-6" />
          </button>
          <h2 className="text-lg font-semibold text-gray-800">
            Configurations
          </h2>
        </div>

        {/* {configData && configData.length > 0 ? (
          <button className="">
            <Link
              to={`/catalog/products/${id}/product-variants/edit/1?product_name=${encodeURIComponent(
                productName
              )}&config_data=${encodeURIComponent(JSON.stringify(configData))}`}
              className="px-4 py-2 bg-gray-900 text-white text-sm  rounded-md hover:bg-gray-800"
            >
              Edit Configuration
            </Link>
          </button>
        ) : (
          <button className="">
            <Link
              to={`/catalog/products/${id}/product-variants/edit/1?product_name=${encodeURIComponent(
                productName
              )}`}
              className="px-4 py-2 bg-gray-900 text-white text-sm  rounded-md hover:bg-gray-800"
            >
              Create Configuration
            </Link>
          </button>
        )} */}
        <button className="">
          <Link
            to={`/catalog/products/${id}/product-variants/edit/1?product_name=${encodeURIComponent(
              productName
            )}`}
            className="px-4 py-2 bg-gray-900 text-white text-sm  rounded-md hover:bg-gray-800"
          >
            Add Configuration
          </Link>
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="bg-gray-50 text-gray-600 uppercase text-xs">
              <th className="text-left px-4 py-3 font-semibold">Images</th>
              <th className="text-left px-4 py-3 font-semibold">Name</th>
              <th className="text-left px-4 py-3 font-semibold">MRP Price</th>
              <th className="text-left px-4 py-3 font-semibold">
                Selling Price
              </th>
              <th className="text-left px-4 py-3 font-semibold">
                Business Selling Price
              </th>
              {/* <th className="text-left px-4 py-3 font-semibold">Quantity</th> */}
              <th className="text-left px-4 py-3 font-semibold">Item Code</th>
              <th className="text-left px-4 py-3 font-semibold">SKU Code</th>
              <th className="text-left px-4 py-3 font-semibold">HSN Code</th>
              <th className="text-left px-4 py-3 font-semibold">Article No.</th>
              <th className="text-left px-4 py-3 font-semibold">
                Parent Article No.
              </th>
              <th className="text-left px-4 py-3 font-semibold">Status</th>
              <th className="text-left px-4 py-3 font-semibold">Attributes</th>
              <th className="text-center px-4 py-3 font-semibold">Action</th>
            </tr>
          </thead>
          <tbody>
            {(configData || []).map((item) => (
              <tr
                key={item.id}
                className="border-t hover:bg-gray-50 transition-colors"
              >
                <td className="px-4 py-3">
                  <div className="w-12 h-12 border border-dashed border-gray-300 flex items-center justify-center rounded-md">
                    <span className="text-xl text-gray-400">
                      <HiCamera />
                    </span>
                  </div>
                  <span className="text-xs text-gray-500">No Image</span>
                </td>
                <td className="px-4 py-3">
                  <div className="text-gray-800 font-medium">{item.name}</div>
                </td>
                <td className="px-4 py-3">
                  ₹{parseFloat(item.mrp_price || 0).toFixed(2)}
                </td>
                <td className="px-4 py-3">
                  ₹{parseFloat(item.selling_price || 0).toFixed(2)}
                </td>
                <td className="px-4 py-3">
                  ₹{parseFloat(item.business_selling_price || 0).toFixed(2)}
                </td>
                {/* <td className="px-4 py-3">-</td> */}
                <td className="px-4 py-3 text-gray-600">{item?.item_code ? item?.item_code : "---"}</td>
                <td className="px-4 py-3 text-gray-600">{item?.sku_code ? item?.sku_code : "---"}</td>
                <td className="px-4 py-3 text-gray-600">{item?.hsn_code ? item?.hsn_code : "---"}</td>
                <td className="px-4 py-3 text-gray-600">{item?.article_no ? item?.article_no : "---"}</td>
                <td className="px-4 py-3 text-gray-600">{item?.parent_article_no ? item?.parent_article_no : "---"}</td>
                <td className="px-4 py-3 text-gray-600">
                  {item.status ? "Enabled" : "Disabled"}  
                </td>
                <td className="px-4 py-3 text-gray-600">
                  {item.attributes
                    ?.map((attr) => attr.attribute_value_name)
                    .join(", ")}
                </td>
                <td className="px-4 py-3 text-center">
                  <Link to={`/catalog/products/edit-product/${item.id}`}>
                    <button className="text-gray-500 hover:text-gray-900 transition">
                      <HiOutlinePencilSquare size={20} />
                    </button>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductsVariants;
